import React from 'react';
import Typed from 'react-typed';
import SEO from "../common/SEO";
import {Link} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import HeaderOne from '../common/header/HeaderOne';
import HeaderTopBar from '../common/header/HeaderTopBar';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import AboutAccessibility from '../elements/about/AboutAccessibility';
import Separator from "../elements/separator/Separator";

const Accessibility = () => {
    return (
        <>
            <SEO title="Accessibility" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

               
                <Separator />

                {/* Start About Area  */}
                <AboutAccessibility/>                            
                {/* End About Area  */}

                

                <Separator />   
               
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default Accessibility;